
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"height":"18","maskUnits":"userSpaceOnUse","width":"16","x":"4","y":"3"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"m10.56 18.8727h-3.59995c-.39765 0-.72-.3419-.72-.7636v-12.21818c0-.42175.32235-.76364.72-.76364h3.59995c.3977 0 .72-.34189.72-.76364 0-.42174-.3223-.76363-.72-.76363h-3.59995c-1.19294 0-2.16 1.02567-2.16 2.29091v12.21818c0 1.2652.96706 2.2909 2.16 2.2909h3.59995c.3977 0 .72-.3419.72-.7636 0-.4218-.3223-.7637-.72-.7637zm4.531-4.3579c-.2812.2982-.2812.7817 0 1.0799.2812.2983.7371.2983 1.0182 0l2.88-3.0545c.2685-.2847.2806-.7382.0366-1.0382-.0137-.0169-.028-.033-.0429-.0485l-2.8737-3.0478c-.2811-.29822-.737-.29822-1.0182 0s-.2812.78173 0 1.07995l1.6506 1.75055h-6.90173c-.39764 0-.72.3419-.72.7637 0 .4217.32236.7636.72.7636h6.90233z","fill":"#fff","fill-rule":"evenodd"}})]),_c('path',{attrs:{"clip-rule":"evenodd","d":"m10.56 18.8727h-3.59995c-.39765 0-.72-.3419-.72-.7636v-12.21818c0-.42175.32235-.76364.72-.76364h3.59995c.3977 0 .72-.34189.72-.76364 0-.42174-.3223-.76363-.72-.76363h-3.59995c-1.19294 0-2.16 1.02567-2.16 2.29091v12.21818c0 1.2652.96706 2.2909 2.16 2.2909h3.59995c.3977 0 .72-.3419.72-.7636 0-.4218-.3223-.7637-.72-.7637zm4.531-4.3579c-.2812.2982-.2812.7817 0 1.0799.2812.2983.7371.2983 1.0182 0l2.88-3.0545c.2685-.2847.2806-.7382.0366-1.0382-.0137-.0169-.028-.033-.0429-.0485l-2.8737-3.0478c-.2811-.29822-.737-.29822-1.0182 0s-.2812.78173 0 1.07995l1.6506 1.75055h-6.90173c-.39764 0-.72.3419-.72.7637 0 .4217.32236.7636.72.7636h6.90233z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    